import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container block" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "search border-b-2px border-#000 solid" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "flex flex-ai-start gap-16" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"font-weight":"bold"} }
const _hoisted_9 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createTextVNode(" 归档时间 ")),
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.fileTime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileTime) = $event)),
            type: "daterange",
            class: "date-solt screen-i",
            "unlink-panels": "",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue"]),
          _cache[11] || (_cache[11] = _createTextVNode(" 创建时间 ")),
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.creationTime,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.creationTime) = $event)),
            type: "daterange",
            class: "date-solt screen-i",
            "unlink-panels": "",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue"]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入人员/项目名称",
            class: "input search-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchText) = $event)),
            onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchText]
          ]),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, "搜索"),
          _createElementVNode("button", {
            class: "btn-white",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
          }, "重置")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex flex-jc-end border-top" }, null, -1)),
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' },
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "projectName",
              width: "150",
              label: "项目名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "contacts",
              label: "负责人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "pwCount",
              width: "90",
              label: "总人数"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              width: "200",
              label: "创建时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "operator",
              label: "归档人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "archivedRemark",
              width: "200",
              label: "备注"
            }),
            _createVNode(_component_el_table_column, {
              prop: "archivedTime",
              width: "200",
              label: "归档时间"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "130",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", {
                    style: {"color":"#1989FA"},
                    class: "point",
                    onClick: ($event: any) => (_ctx.$router.push({ path: '/project/place/detail/' + scope.row.id }))
                  }, " 查看详情 ", 8, _hoisted_6),
                  _createElementVNode("p", {
                    class: "link",
                    onClick: ($event: any) => (_ctx.recovery(scope.row.id))
                  }, " 恢复 ", 8, _hoisted_7)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isDeletePopup,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isDeletePopup) = $event)),
      title: "提示",
      width: "450px",
      top: "15%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isDeletePopup = false))
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onDelete
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("确定")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _cache[13] || (_cache[13] = _createTextVNode("已选定 ")),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.selects.length), 1),
          _cache[14] || (_cache[14] = _createTextVNode(" 条归档项目，删除后将不可恢复，是否确定删除？"))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}